import type { SiteImage } from '../types/content'

export const images: Record<'hero' | 'care' | 'family' | 'team' | 'home', SiteImage> = {
  hero: {
    src: 'https://cdn.magicpatterns.com/uploads/sGwcqH27YmDhVpm2ME1po8/Banner_A.M_Homer_Care.jpg',
    alt: {
      en: 'A.M. Home Care caregiver holding hands and smiling with a senior woman in her living room',
      es: 'Cuidadora de A.M. Home Care tomando las manos y sonriendo con una señora mayor en su sala',
    },
  },
  care: {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/2fd8bcc7-6bce-4eb3-8047-744c2e150171.jpg',
    alt: {
      en: 'Caregiver helping a senior organize her weekly medication at the kitchen table',
      es: 'Cuidadora ayudando a una señora mayor a organizar sus medicamentos semanales en la mesa de la cocina',
    },
  },
  family: {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/f7238334-1746-40e3-9094-145b516d40d0.jpg',
    alt: {
      en: 'Smiling grandfather at home with his caregiver and his daughter',
      es: 'Abuelo sonriente en casa con su cuidadora y su hija',
    },
  },
  team: {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/8a0b0608-4a8c-4d81-b4e8-97b36975f150.jpg',
    alt: {
      en: 'The A.M. Home Care team of bilingual caregivers',
      es: 'El equipo de cuidadores bilingües de A.M. Home Care',
    },
  },
  home: {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/e5997369-fb7b-4ddc-91d2-5a79f4d4e6c8.jpg',
    alt: {
      en: 'A bright, safe, senior-friendly living room with clear walkways',
      es: 'Una sala luminosa, segura y adaptada para personas mayores, con pasillos despejados',
    },
  },
}
